import { Button, Col, Modal, Row, Form as BForm } from '@themesberg/react-bootstrap'
import { ErrorMessage, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { getAllPortalsStart } from '../../../store/redux-slices/tenants.js'
import { bannerType } from './constants.js'
import { uploadBannerSchema } from './schema.js'

const EditUploadBanner = ({
  type,
  data,
  show,
  setShow,
  createUpdate,
  clientsFilterData,
  portalsFilterData,
  dispatch,
  SABanners,
  validation,
  setValidation
}) => {
  const [selectedClient, setSelectedClient] = useState('')
  useEffect(() => {
    if (selectedClient) {
      dispatch(getAllPortalsStart({ adminId: selectedClient }))
    }
  }, [selectedClient])

  useEffect(() => {
    data?.adminId && setSelectedClient(data?.adminId)
  }, [data?.adminId])
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{type} Banner </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              thumbnail: data?.thumbnail,
              adminId: data?.adminId || '',
              tenantId: data?.tenantId || '',
              pageBannerId: data?.pageBannerId,
              // bannerType: bannerType?.find((item) => item?.value === data?.bannerType)?.value || '',
              url: data?.url || '',
              name: data?.name || ''
            }}
            validationSchema={uploadBannerSchema(
              {
                type,
                minRequiredWidth: validation?.minRequiredWidth,
                minRequiredHeight: validation?.minRequiredHeight,
                maxRequiredWidth: validation?.maxRequiredWidth,
                maxRequiredHeight: validation?.maxRequiredHeight
              })}
            onSubmit={(formValues) => {
              createUpdate(formValues)
              setShow(false)
            }}
          >
            {({
              values,
              errors,
              handleSubmit,
              handleBlur,
              setFieldValue,
              handleChange
            }) => (
              <Form>
               <Row className='mt-3'>
                  <Col className='d-flex align-items-center'>
                    <Col>
                      <BForm.Label>Name
                        <span className='text-danger'> *</span>
                      </BForm.Label>
                    </Col>

                    <Col xs={9}>
                      <BForm.Control
                        type='text'
                        name='name'
                        placeholder='Enter Name'
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      <ErrorMessage
                        component='div'
                        name='name'
                        className='text-danger'
                      />
                    </Col>
                  </Col>
                </Row>





                <Row className='mt-3'>
                  <Col className='d-flex align-items-center'>
                    <Col>
                      <BForm.Label>Banner
                        <span className='text-danger'> *</span>
                      </BForm.Label>
                    </Col>

                    <Col xs={9}>
                      <BForm.Control
                        type='file'
                        name='thumbnail'
                        accept=".jpg,.jpeg,.png,.webp"
                        // disabled={!values?.bannerType}
                        onChange={(event) => setFieldValue('thumbnail', event.target.files[0])}
                        onBlur={handleBlur}
                      />

                      <ErrorMessage
                        component='div'
                        name='thumbnail'
                        className='text-danger'
                      />
                    </Col>
                  </Col>
                </Row>

                {!errors?.thumbnail &&
                  (type === 'Create'
                    ? values?.thumbnail &&
                    <Row className='text-center'>
                      <Col>
                        <img
                          alt='not found'
                          className='mt-2'
                          style={{ maxWidth: '300px', maxHeight: '300px' }}
                          src={
                            values?.thumbnail &&
                            URL.createObjectURL(values?.thumbnail)
                          }
                        />
                      </Col>
                    </Row>
                    : (
                      <Row className='text-center'>
                        <Col>
                          {/* <img
                            alt='not found'
                            className='mt-2'
                            style={{ maxWidth: '300px', maxHeight: '300px' }}
                            src={
                              values?.thumbnail
                                ? URL.createObjectURL(values?.thumbnail)
                                : `${process.env.REACT_APP_S3_URL}${data?.thumbnail}`
                            }
                          /> */}
                          <img
                            alt="not found"
                            className="mt-2"
                            style={{ maxWidth: "300px", maxHeight: "300px" }}
                            src={
                              values.thumbnail
                                ? typeof values.thumbnail === 'string'
                                  ? `${process.env.REACT_APP_S3_URL}/${values.thumbnail}`
                                  : URL.createObjectURL(values.thumbnail)
                                : ''
                            }
                          />
                        </Col>
                      </Row>))}


                


                <div className='mt-4 d-flex justify-content-between align-items-center'>
                  <Button
                    className='btn-danger'
                    onClick={() => setShow(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className='btn-primary ml-2'
                    disabled={!values?.thumbnail}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal >
    </>
  )
}

export default EditUploadBanner
